/**
 * External Dependencies
 */
import 'jquery';


import Router from './util/Router';


import once from './routes/once'
import common from './routes/common'
import home from './routes/home'
import product from './routes/product'
import checkout from './routes/checkout'
import cart from './routes/cart'
import contact from './routes/contact'

const routes = new Router({
  common,
  home,
  product,
  checkout,
  cart,
  contact,
})

jQuery(document).ready(() => {
    once.init()
    routes.loadEvents()
    once.finalize()
});
